import { EmailSubscription } from "src/app/models/EmailSubscription";

import { IDeserialize } from "./abstraction/IDeserialize";
import { Company } from "./Company";
import { PlanningBoardRole } from "./PlanningBoardRole";
import { UserSubscription } from "./UserSubscription";
import { UserVendor } from "./UserVendor";
import { UserWithRole } from "./UserWithRole";

export class User extends UserWithRole implements IDeserialize<User> {
  azureObjectId: string;
  companies: Company[] = [];
  createDate: Date;
  email: string;
  emailSubscriptions: EmailSubscription[];
  famcodes: string[] = [];
  firstName: string;
  lastName: string;
  passwordHash: string;
  phoneNumber: string;
  subscriptions: UserSubscription[];
  userId: number;
  userVendors: UserVendor[] = [];
  planningBoardRole: PlanningBoardRole;
  pbUserList: PlanningBoardRole[];
  isItemLoading: boolean;
  isFieldServiceUser: boolean;
  isEquipmentAdministrationUser: boolean;
  address: string;
  // Set by the backend when a user is loaded individually; false means the user no longer
  // exists in Microsoft Entra and should be deleted/cleaned up. Defaults to true elsewhere.
  existsInEntra = true;

  constructor() {
    super();
    super.setUserRole();
  }

  public setUserRole(): void {
    super.setUserRole();
  }

  public deserialize(dto: User): User {
    Object.assign(this, dto);

    this.setUserRole();

    return this;
  }
}
